import React, { useState } from "react";
import {
  Row,
  Col,
  Modal,
  Form,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import ApiRow from "../../../Settings/apiRow";
import Backend from "../../../../Backend";
import Connection from "../../../../Calls";
import { store } from "react-notifications-component";

import ModalChangePass from "../../../Settings/changePassModal";
import Activate2FA from "../../../Settings/activate2FA";
import Disable2FA from "../../../Settings/disable2FA";

import { changeLang } from "./utils";

const Services = ({
  data,
  Api_keys,
  GetGroupInfo,
  GetTwoFa,
  GetApiKeys,
  type,
  history,
  pending_upgrade,
  traductions,
}) => {
  const [Show_TransferAlias, setShow_TransferAlias] = useState(false);
  const [Show_Password, setShow_Password] = useState(false);
  const [Show_TwoFA, setShow_TwoFA] = useState(false);

  const [ContentModal, setContentModal] = useState("");
  const [NewAlias, setNewAlias] = useState("");
  const [AliasProps, setAliasProps] = useState({
    class_input: "",
    class_alias_note: "",
    correctAlias: false,
  });
  const [Password, setPassword] = useState({
    Current: "",
    New: "",
    Confirm: "",
  });
  const [CurrentLang, setCurrentLang] = useState(
    localStorage.getItem("lan") == "es"
      ? traductions.settings.services.L_langS
      : traductions.settings.services.L_langE
  );

  // ------------------------ Methods ------------------------
  const addNotification = (status, msg, type) => {
    store.addNotification({
      title: status,
      message: msg,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 2500,
        onScreen: true,
      },
    });
  };

  const hendleClosePassworModal = () => {
    setShow_Password(false);
    setPassword({
      Current: "",
      New: "",
      Confirm: "",
    });
  };

  // ------------------------ CALLS ------------------------

  const verifyAlias = (Alias) => {
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });

    result = latitude + longitude;

    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        var payload = response.payload;
        Backend.VerifyAlias(
          localStorage.getItem("email"),
          Alias,
          "verify",
          "-",
          localStorage.getItem("token"),
          payload.r01,
          (response) => {
            if (response.status.code == 0) {
              if (response.payload.message === "Available") {
                const regex = /^[a-zA-Z0-9]+$/g;
                var m = regex.exec(Alias);
                if (m && Alias.length > 7 && Alias.length < 33) {
                  setAliasProps({
                    class_input: "alias-success",
                    class_alias_note: "",
                    correctAlias: true,
                  });
                } else {
                  setAliasProps({
                    class_input: "alias-error",
                    class_alias_note: "alias-error-note",
                    correctAlias: false,
                  });
                }
              } else {
                setAliasProps({
                  ...AliasProps,
                  class_input: "",
                });
              }
            }
          }
        );
      }
    );
    setNewAlias(Alias);
  };

  const updateAlias = (code) => {
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });

    result = latitude + longitude;

    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        var payload = response.payload;
        if (AliasProps.correctAlias) {
          Backend.VerifyAlias(
            localStorage.getItem("email"),
            NewAlias,
            "update",
            code,
            localStorage.getItem("token"),
            payload.r01,
            (response) => {
              if (response.status.code == 0) {
                GetGroupInfo();
                window.localStorage.setItem("alias", NewAlias);
                setAliasProps({
                  class_input: "",
                  class_alias_note: "",
                  correctAlias: false,
                });
                setNewAlias("");
                setShow_TransferAlias(false);
                addNotification(
                  "Success!",
                  response.payload.message,
                  "success"
                );
              } else {
                addNotification(
                  "Error!",
                  response.status.description,
                  "danger"
                );

                this.setState({ showLoad: false });
              }
            }
          );
        } else {
          addNotification("Error!", "The alias is the same", "danger");
        }
      }
    );
  };

  const changeWhiteList = () => {
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });

    result = latitude + longitude;

    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Backend.WhiteListStatus(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          response.payload.r01,
          (response) => {
            if (response.status.code == 0) {
              addNotification("Success!", response.payload.message, "success");
              GetGroupInfo();
            } else {
              addNotification("Error!", response.status.description, "danger");
            }
          }
        );
      }
    );
  };

  const createAPIKey = () => {
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        var payload = response.payload;
        Backend.CreateAPIKey(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          payload.r01,
          (response) => {
            if (response.status.code === "0") {
              addNotification("Success!", response.payload.message, "success");
              GetApiKeys();
            } else {
              addNotification("Error!", response.status.description, "danger");
            }
          }
        );
      }
    );
  };

  // ------------------------ Render ------------------------

  const renderModal_TransferAlias = () => {
    return (
      <Modal
        show={Show_TransferAlias}
        onHide={() => setShow_TransferAlias(false)}
        centered
      >
        <Modal.Body>
          <div>
            <p className="TituloModal">Actual alias:</p>
            <p style={{ textAlign: "center", color: " #0F4C81" }}>
              {data.TransfersAlias}
            </p>
            <Form.Group>
              <Form.Label className="virtual_exchange_information_wallets_text">
                {traductions.settings.services.modalAlis.L_newAlias}
              </Form.Label>
              <Form.Control
                value={NewAlias}
                onChange={(aliasValue) => {
                  verifyAlias(aliasValue.target.value);
                }}
                className={"input-Formulario " + AliasProps.class_input}
                type="text"
              />
            </Form.Group>
            <p className={"password-notice " + AliasProps.class_alias_note}>
              {traductions.settings.services.modalAlis.note}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              updateAlias();
            }}
            className="Btn_choosePlan"
          >
            {traductions.settings.services.modalAlis.btn_save}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  const renderModal_Password = () => {
    return (
      <ModalChangePass
        handleChangeModal={hendleClosePassworModal}
        changeModal={Show_Password}
        traductions={traductions}
      />
    );
  };

  const renderModal_TwoFa = () => {
    if (data.twofa.status == "disabled")
      return (
        <Activate2FA
          refresh2FA={GetTwoFa}
          handleActivateModal={() => setShow_TwoFA(false)}
          {...data.twofa}
          activateModal={Show_TwoFA}
          traductions={traductions}
        />
      );
    else
      return (
        <Disable2FA
          refresh2FA={GetTwoFa}
          handleDeactivateModal={() => setShow_TwoFA(false)}
          {...data.twofa}
          deactivateModal={Show_TwoFA}
          traductions={traductions}
        />
      );
  };

  const renderApiKeys = () => {
    return Api_keys.map((item) => {
      return <ApiRow {...item} />;
    });
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p className="title-container-shadow" style={{ marginBottom: 16 }}>
          {traductions.settings.tab_Services}
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className={"virtual_exchange_dropdown"}
        >
          <p style={{ margin: 0, marginRight: 20 }}>
            {traductions.settings.services.L_lang}:{" "}
          </p>
          <DropdownButton
            className=""
            title={CurrentLang}
            style={{ width: "100px" }}
          >
            <Dropdown.Item
              onClick={() => changeLang("en", setCurrentLang, traductions)}
              as="button"
            >
              {traductions.settings.services.L_langE}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => changeLang("es", setCurrentLang, traductions)}
              as="button"
            >
              {traductions.settings.services.L_langS}
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </div>
      <div className="Data Services">
        <Row>
          <Col xl={3} lg={6} md={6} sm={12}>
            <p>{traductions.settings.services.L_Alias}: </p>
            <p>{data.TransfersAlias}</p>
            <button
              onClick={() => {
                setShow_TransferAlias(true);
              }}
              className="Btn_choosePlan"
            >
              {" "}
              {traductions.settings.services.btn_Alias}{" "}
            </button>
          </Col>
          <Col xl={3} lg={6} md={6} sm={12}>
            <p>{traductions.settings.services.L_Passwor}</p>
            <button
              onClick={() => {
                setShow_Password(true);
              }}
              className="Btn_choosePlan btn_pss"
            >
              {" "}
              {traductions.settings.services.L_Passwor}{" "}
            </button>
          </Col>
          <Col xl={3} lg={6} md={6} sm={12}>
            <p>{traductions.settings.services.L_whiteList}:</p>
            <p className={data.whitelist_status}>
              {traductions.settings.services.L_status}:{" "}
              {data.whitelist_status != "enabled"
                ? traductions.settings.services.L_statusD
                : traductions.settings.services.L_statusE}
            </p>
            <button
              onClick={() => {
                changeWhiteList();
              }}
              className="Btn_choosePlan"
            >
              {" "}
              {data.whitelist_status == "enabled"
                ? traductions.settings.services.btn_statusD
                : traductions.settings.services.btn_statusE}{" "}
              {traductions.settings.services.L_whiteList}
            </button>
          </Col>
          <Col xl={3} lg={6} md={6} sm={12}>
            <p>2FA:</p>
            <p className={data.twofa.status}>
              {traductions.settings.services.L_status}:{" "}
              {data.twofa.status != "enabled"
                ? traductions.settings.services.L_statusD
                : traductions.settings.services.L_statusE}
            </p>
            <button
              onClick={() => {
                setShow_TwoFA(true);
              }}
              className="Btn_choosePlan"
            >
              {" "}
              {data.twofa.status == "enabled"
                ? traductions.settings.services.btn_statusD
                : traductions.settings.services.btn_statusE}{" "}
              2FA
            </button>
          </Col>
        </Row>
        <hr />
        <div className="table-api-keys">
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "space-between",
            }}
          >
            <p className="title-container-shadow" style={{ marginBottom: 0 }}>
              Api Keys
            </p>
            {type != "free" && data.ApiStatus == "enabled" && (
              <button className="Btn_choosePlan" onClick={() => createAPIKey()}>
                {" "}
                {traductions.settings.services.btnCreateKey}
              </button>
            )}
          </div>

          {type != "free" ? (
            <>
              <table className="table-container-wallets-generals">
                <thead>
                  <tr>
                    <th className="header-table-wallets-generals fixxxed">
                      API Key
                    </th>
                    <th className="header-table-wallets-generals fixxxed">
                      {traductions.settings.services.T_H_status}
                    </th>
                    <th className="header-table-wallets-generals fixxxed">
                      {traductions.settings.services.T_H_lastUse}
                    </th>
                    <th className="header-table-wallets-generals fixxxed">
                      API Secret
                    </th>
                    <th className="header-table-wallets-generals fixxxed">
                      API Totp
                    </th>
                    <th className="header-table-wallets-generals fixxxed"></th>
                  </tr>
                </thead>
                <tbody>{renderApiKeys()}</tbody>
              </table>
            </>
          ) : pending_upgrade == "True" ? (
            <div className="incompleteRecord">
              <p style={{ textAlign: "center", margin: 0 }}>
                {traductions.General.registerResponse.revision}
              </p>
            </div>
          ) : (
            <div className="incompleteRecord">
              <p style={{ textAlign: "center" }}>
                {traductions.General.registerResponse.unregistered1}
              </p>
              <p>
                {traductions.General.registerResponse.unregistered2}{" "}
                <span className="link" onClick={() => history.push("/kyc")}>
                  {traductions.General.registerResponse.click}
                </span>
              </p>
            </div>
          )}
        </div>
      </div>

      {renderModal_TransferAlias()}
      {renderModal_Password()}
      {renderModal_TwoFa()}
    </>
  );
};

export default Services;

{
  /* <p>Wirebit Transfers Alias:</p>
<p>Note: Choose wisely your Alias. Do not use special characters or spaces, 8 min to 32 max characters.</p>
<hr/>
<p>Change Password:</p>

<p>Note: remember that your account password is diferent than your wallet password, this will only affect your log in</p>
<hr/>
<p>2FA:</p>
<hr/>
<p>White List:</p>
<hr/>
<p>Api Keys:</p> */
}
